import { Link } from "react-router-dom";
import { FileText } from "lucide-react";
import PageMeta from "./PageMeta";

// The most recent set of meeting minutes.
const currentMinutes = {
  label: "October 2026 Meeting",
  date: "5 October 2026",
  file: "/assets/Minutes_October_2026_meeting.pdf",
};

// Add older minutes here once they are superseded by newer ones.
const previousMinutes = [
  {
    label: "September 2026 Meeting",
    date: "September 2026",
    file: "/assets/Minutes_September_2026_meeting.pdf",
  },
  {
    label: "July 2026 Meeting",
    date: "July 2026",
    file: "/assets/RSAA_Minutes_july_meeting.pdf",
  },
  {
    label: "June 2026 Meeting",
    date: "June 2026",
    file: "/assets/RSAA_Minutes_June_meeting.pdf",
  },
  {
    label: "May 2026 Meeting",
    date: "May 2026",
    file: "/assets/RSAA_Minutes_May_meeting.pdf",
  },
  {
    label: "April 2026 Meeting",
    date: "13 April 2026",
    file: "/assets/RSAA_Minutes_April_meeting.pdf",
  },
  {
    label: "March 2026 Meeting",
    date: "4 March 2026",
    file: "/assets/Minutes_March_meeting_final_4_3_26.pdf",
  },
];

function MinutesCard({ item, colorClass, borderHover, bgHover, badgeBorder, badgeBg, badgeText }) {
  return (
    <a
      href={item.file}
      target="_blank"
      rel="noopener noreferrer"
      className={`flex items-center gap-5 rounded-2xl border border-white/10 bg-white/5 p-5 transition ${borderHover} ${bgHover}`}
    >
      <div className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl ${colorClass}`}>
        <FileText className="h-6 w-6" />
      </div>
      <div className="min-w-0 flex-1">
        <p className="font-semibold text-white">{item.label}</p>
        <p className="mt-0.5 text-xs text-slate-400">{item.date}</p>
      </div>
      <span className={`shrink-0 rounded-lg border ${badgeBorder} ${badgeBg} px-3 py-1 text-xs font-medium ${badgeText}`}>
        Open PDF
      </span>
    </a>
  );
}

export default function MinutesPage() {
  return (
    <div className="page-shell min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 text-white">
      <PageMeta title="Meeting Minutes | Redruth Sea Angling Association" noindex />
      <div className="mx-auto max-w-4xl px-6 py-16 sm:px-8 lg:px-12">

        <div className="flex flex-wrap gap-3">
          <Link to="/" className="standalone-only inline-flex items-center gap-2 rounded-lg border border-cyan-300/40 bg-cyan-400/10 px-4 py-2 text-sm text-cyan-200 transition hover:bg-cyan-400/20">
            ← Back
          </Link>
          <Link to="/members" className="inline-flex items-center gap-2 rounded-lg border border-white/10 bg-white/5 px-4 py-2 text-sm text-slate-300 transition hover:bg-white/10">
            Members' Documents
          </Link>
        </div>

        <div className="mt-8">
          <p className="text-sm font-semibold uppercase tracking-[0.3em] text-cyan-300">Redruth Sea Angling Association</p>
          <h1 className="heading-glow mt-3 text-4xl font-bold tracking-tight text-white sm:text-5xl">Meeting Minutes</h1>
        </div>

        {/* Current Minutes */}
        <div className="mt-10">
          <h2 className="text-xl font-semibold text-cyan-300 mb-4">Latest Meeting Minutes</h2>
          {currentMinutes ? (
            <MinutesCard
              item={currentMinutes}
              colorClass="bg-cyan-400/10 text-cyan-300"
              borderHover="hover:border-cyan-300/30"
              bgHover="hover:bg-cyan-400/5"
              badgeBorder="border-cyan-300/20"
              badgeBg="bg-cyan-400/10"
              badgeText="text-cyan-300"
            />
          ) : (
            <p className="text-slate-400">No current minutes have been published yet.</p>
          )}
        </div>

        {/* Previous Minutes */}
        <div className="mt-12">
          <h2 className="text-xl font-semibold text-slate-300 mb-4">Archived Meeting Minutes</h2>
          {previousMinutes.length === 0 ? (
            <p className="text-slate-400">No previous minutes yet.</p>
          ) : (
            <div className="space-y-4">
              {previousMinutes.map((item) => (
                <MinutesCard
                  key={item.file}
                  item={item}
                  colorClass="bg-slate-400/10 text-slate-300"
                  borderHover="hover:border-slate-300/30"
                  bgHover="hover:bg-slate-400/5"
                  badgeBorder="border-slate-300/20"
                  badgeBg="bg-slate-400/10"
                  badgeText="text-slate-300"
                />
              ))}
            </div>
          )}
        </div>

      </div>
    </div>
  );
}
